import { render, staticRenderFns } from "./DepositWhithoutLogin.vue?vue&type=template&id=15bbf96a&scoped=true&"
import script from "./DepositWhithoutLogin.vue?vue&type=script&lang=js&"
export * from "./DepositWhithoutLogin.vue?vue&type=script&lang=js&"
import style0 from "./DepositWhithoutLogin.vue?vue&type=style&index=0&id=15bbf96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bbf96a",
  null
  
)

export default component.exports